export default __webpack_public_path__ + "921a4fdac53c0b21b4dadea6792b1a9b.png";